export default "__VITE_ASSET__BRnzqH2b__"